import React from 'react';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import { Button, Modal, ModalBody, Input, Form } from 'reactstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import s from '../../assets/styles/style.sass';
import s2 from './dialog.sass';
import {
  setIsShowSMSPhoneDialog,
  setIsShowSMSVerfiyDialog,
  setIsSendingSMS,
} from '../../actions/dialog';
import { localStorageGet, localStorageSet } from '../../service/localStorage';
import { userProfileUpdate, sendSMS } from '../../api/user';
import { getAuth } from '../../service/auth';

import imgPhone from '../../assets/img/icon_phone.png';
import imgPhone2 from '../../assets/img/icon_phone@2x.png';

class smsChangePhoneDialog extends React.Component {
  static propTypes = {
    currentLocale: PropTypes.string.isRequired,
    setIsShowSMSPhoneDialog: PropTypes.func.isRequired,
    setIsShowSMSVerfiyDialog: PropTypes.func.isRequired,
    setIsSendingSMS: PropTypes.func.isRequired,
    onSetIsMobilePhone: PropTypes.func.isRequired,
    modal: PropTypes.bool.isRequired,
    second: PropTypes.number.isRequired, // from step-two
    isSendingSMS: PropTypes.bool.isRequired,
    modelDataText: PropTypes.shape().isRequired,
  };
  constructor(props) {
    super(props);
    const lang = props.currentLocale.split('-')[1].toLowerCase();
    this.state = {
      setting: require(`../../assets/src/${lang}/scripts/components/setting.json`),
      errorPhone: false,
      errorPhoneTaken: false,
      phone: localStorageGet('auth.phone', false),
      isClickButton: false,
      errorMessageLocale: require(`../../assets/src/${lang}/scripts/components/setting.json`),
    };
    this.onYes = this.onYes.bind(this);
    this.changePhoneNumber = this.changePhoneNumber.bind(this);
  }
  componentWillUpdate(nextProps, nextState) {
    if (nextState.isClickButton) {
      const phone = document.getElementById('phone');
      const errorMessage = this.state.errorMessageLocale[
        this.props.currentLocale
      ];

      if (phone.value === '' || phone.value === null) {
        phone.setCustomValidity(errorMessage.blank_field);
      } else {
        phone.setCustomValidity('');
      }
      this.onClickisClickButton();
    }
  }
  onClickisClickButton() {
    this.setState({ isClickButton: !this.state.isClickButton });
  }

  onYes() {
    const patt = new RegExp(this.state.setting.PHONE_REGEX);
    if (patt.test(this.state.phone)) {
      this.changePhoneNumber();
      // shouldComponentUpdate
    } else {
      this.setState({ errorPhone: true });
      this.setState({ errorPhoneTaken: false });
    }
  }

  changePhoneNumber() {
    if (
      ['2', '3'].includes(this.state.phone.replace('825', '')[0]) &&
      this.props.currentLocale.split('-')[1].toLowerCase() === 'hk'
    ) {
      this.props.onSetIsMobilePhone(false);
    } else {
      this.props.onSetIsMobilePhone(true);
    }
    const user = {
      phone_number: this.state.phone,
    };
    userProfileUpdate(getAuth().id, user, this.props.currentLocale).then(
      result => {
        if (result.status === 200 || result.status === 204) {
          result.json().then(res => {
            if (typeof res.name !== 'undefined') {
              localStorageSet('auth.username', res.name);
            }
            if (typeof res.phone_number !== 'undefined') {
              localStorageSet('auth.phone', res.phone_number);
            }
            localStorageSet(
              'auth.has_agreed_to_receive_gogovan_updates',
              res.meta.has_agreed_to_receive_gogovan_updates,
            );
            localStorageSet(
              'auth.has_agreed_to_receive_third_parties_updates',
              res.meta.has_agreed_to_receive_third_parties_updates,
            );

            // open / close dialog
            if (['4', '5'].includes(result.status.toString().split('')[0])) {
              // status error
              this.setState({ errorPhone: false });
              this.setState({ errorPhoneTaken: true });
            } else {
              sendSMS(this.props.currentLocale, this.props.setIsSendingSMS);
              this.setState({ errorPhone: false });
              this.setState({ errorPhoneTaken: false });
              this.props.setIsShowSMSPhoneDialog();
              this.props.setIsShowSMSVerfiyDialog();
            }
          });
        } else {
          console.warn(result.status);
        }
      },
    );
  }

  render() {
    return (
      <div id="smsChangePhoneDialog">
        <Modal
          className={`${s2.dialog} ${s2.infoPopup}`}
          isOpen={this.props.modal}
          toggle={() => {
            this.props.setIsShowSMSPhoneDialog();
          }}
        >
          <Button
            outline
            color="link"
            className={`${s.infoCloseRightButton} ${s2.dialogOverlayClose} ${
              s2.smallcloseRightButton
            }`}
            onClick={() => {
              this.props.setIsShowSMSPhoneDialog();
            }}
          />
          <ModalBody
            className={`${s2.infoContainer} ${s2.orderCancelContainer} ${
              s2.smsContainer
            }`}
          >
            {this.state.errorPhone ? (
              <p className={s2.dialogErrorMessage}>
                {this.props.modelDataText.sms_please_enter_correct_digit_no}
              </p>
            ) : (
              ''
            )}
            {this.state.errorPhoneTaken ? (
              <p className={s2.dialogErrorMessage}>
                {this.props.modelDataText.sms_tel_no_being_taken}
              </p>
            ) : (
              ''
            )}
            <div className={s2.infoContent} style={{ paddingBottom: '20px' }}>
              <Form>
                <h2 style={{ marginBottom: '0px' }}>
                  {this.props.modelDataText.sms_verification}
                </h2>
                <br />
                <p>{this.props.modelDataText.sms_please_enter_tel_no}</p>
                <br />
                <div className={s2.smsPhone}>
                  <Input
                    type="text"
                    className={s2.smsDialog}
                    id="phone"
                    name="phone"
                    placeholder="Phone"
                    value={this.state.phone}
                    onChange={e => {
                      this.setState({ phone: e.target.value });
                    }}
                    disabled={this.props.isSendingSMS}
                  />
                  <img
                    srcSet={`${imgPhone} 1x, ${imgPhone2} 2x`}
                    width="24"
                    className={`${s2.smsImg}`}
                    alt="phone"
                  />
                </div>
                {!this.props.isSendingSMS ? (
                  <Button
                    className={`${s.button} ${s.primary} ${s.globalTextBlue}`}
                    style={{ width: '100%' }}
                    onClick={() => {
                      this.onClickisClickButton();
                      this.onYes();
                    }}
                  >
                    {this.props.modelDataText.sms_change}
                  </Button>
                ) : (
                  <Button
                    className={`${s2.buttonTwoLine} ${s2.disabled} ${
                      s2.buttonDisableBG
                    }`}
                    style={{ width: '100%' }}
                    onClick={() => {}}
                  >
                    <span className={s2.disableText}>
                      {this.props.modelDataText.sms_verification}
                    </span>
                    <br />
                    <span className={s2.disableText}>
                      ({this.props.modelDataText.sms_sec_remaining_prefix}
                      {this.props.second}
                      {this.props.modelDataText.sms_sec_remaining_suffix})
                    </span>
                  </Button>
                )}
              </Form>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}
const mapState = state => ({
  currentLocale: state.intl.locale,
  modal: state.dialog.isShowSMSPhoneDialog,
  isSendingSMS: state.dialog.isSendingSMS,
});
const mapDispatch = {
  setIsShowSMSPhoneDialog,
  setIsShowSMSVerfiyDialog,
  setIsSendingSMS,
};
export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s, s2)(smsChangePhoneDialog),
);



// WEBPACK FOOTER //
// ./src/components/Dialog/smsChangePhoneDialog.js